/** @typedef {import('./SubscriptionCard/Props').SharedProps} Props */

import { translate } from '../../App/Internationalization';
import ExternalAnchorButton from '../ExternalAnchorButton';
import Loading from '../Loading';
import React from 'react';

const btnClass = 'button w-full p-3 text-ms-3';

/**
 * @param {Props} props
 * @returns	{JSX.Element}
 */
function SubscribeButton(props) {
	if (props?.isGettingData) {
		return (
			<div className={`${btnClass} pointer-events-none`}>
				<div className="-my-19 -scale-50">
					<Loading />
				</div>
			</div>
		);
	}

	const tier = props?.tier?.title;
	const url = props?.paymentLinks?.[tier]?.url;

	if (!url) {
		return (
			<button className={btnClass} disabled={true} type="button">
				{translate('subscription.plans.unavailable')}
			</button>
		);
	}

	return (
		<ExternalAnchorButton className={btnClass} href={url} target="_self">
			{translate('subscription.plans.cta')}
		</ExternalAnchorButton>
	);
}

export default React.memo(SubscribeButton);
